/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FoldersIcon16Light } from './FoldersIcon16Light';
import { FoldersIcon16Regular } from './FoldersIcon16Regular';
import { FoldersIcon16Solid } from './FoldersIcon16Solid';
import { FoldersIcon20Light } from './FoldersIcon20Light';
import { FoldersIcon20Regular } from './FoldersIcon20Regular';
import { FoldersIcon20Solid } from './FoldersIcon20Solid';
import { FoldersIcon24Regular } from './FoldersIcon24Regular';
import { FoldersIcon24Solid } from './FoldersIcon24Solid';
import { FoldersIcon32Regular } from './FoldersIcon32Regular';
import { FoldersIcon64Regular } from './FoldersIcon64Regular';
var sizes = {
    16: {
        light: FoldersIcon16Light,
        regular: FoldersIcon16Regular,
        solid: FoldersIcon16Solid,
    },
    20: {
        light: FoldersIcon20Light,
        regular: FoldersIcon20Regular,
        solid: FoldersIcon20Solid,
    },
    24: {
        regular: FoldersIcon24Regular,
        solid: FoldersIcon24Solid,
    },
    32: {
        regular: FoldersIcon32Regular,
    },
    64: {
        regular: FoldersIcon64Regular,
    },
};
export var FoldersIcon = forwardRef('FoldersIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
